import { Component, OnDestroy, OnInit, ViewChild } from '@angular/core';
import { FormControl } from '@angular/forms';
import { MatDialogRef } from '@angular/material/dialog';
import { Subscription } from 'rxjs';
import { debounceTime } from 'rxjs/operators';
import { NotificationService } from 'src/app/core/services/notification.service';
import { UploadFileService } from 'src/app/core/services/upload-file.service';
import { IShopBase, IShopFilter } from '../../../../core/models/shop.interface';
import { SaleOrderService } from '../../services/sale-order.service';

// TO DO - NEED TO MOVE THIS COMPONENT TO SHARED
@Component({
    selector: 'eci-xlsx-upload-popup',
    templateUrl: './xlsx-upload-popup.component.html',
    styleUrls: ['./xlsx-upload-popup.component.scss']
})
export class XlsxUploadPopupPopupComponent implements OnInit, OnDestroy {

    listOfShops: IShopBase[] = [];
    selectedShop: number;
    searchShopIdDropDown: FormControl = new FormControl('');
    sub$: Subscription = new Subscription();
    public shopFilter: IShopFilter = { limit: 50, page: 0, q: '', totalPages: 0 };
    

    @ViewChild('fileInput') fileInput: any;

    get isUploadDisabled(): boolean {
        return !this.selectedShop;
    }

    constructor(
        private dialog: MatDialogRef<XlsxUploadPopupPopupComponent>,
        private saleOrderSvc: SaleOrderService,
        public uploadFileSvc: UploadFileService,
        private notify: NotificationService
    ) {
    }

    ngOnInit(): void {
        this.getShopsData();
        this.searchShopIdDropDown.valueChanges.pipe(debounceTime(500)).subscribe(value => {
            if (value?.length < 2) {
                return;
            }
            this.shopFilter = { limit: 50, page: 0, q: value , totalPages: 0 };
            this.getShopsData();
        });
    }

    add(shopId: number = this.selectedShop): void {
        this.dialog.close(shopId);
    }

    public getShopsData(): void {
        this.shopFilter.page += 1;
        this.saleOrderSvc.getShops(this.shopFilter).subscribe((shopsPaginator) => {
            if (!shopsPaginator) {
                return;
            }
            this.listOfShops = (shopsPaginator.meta.currentPage > 1) ?
                [...this.listOfShops, ...shopsPaginator.items] :
                this.listOfShops = shopsPaginator.items;
            this.shopFilter.page = shopsPaginator.meta.currentPage;
            this.shopFilter.totalPages = shopsPaginator.meta.totalPages;
        });
    }

    
    uploadExcel(e): void {
        if (!e.target.files) {
            return;
        }
        const files = e.dataTransfer ? e.dataTransfer.files : e.target.files;
        if (!this.uploadFileSvc.excelFileFormats[0].split(', ').find(el => el === files[0].type)) {
            this.fileInput.nativeElement.value = '';
            this.notify.showError('Should contain only XLSX files');
            return;
        }
        this.uploadFileSvc.uploadSeveralFile(files, `xlsx-sale-order-files/${this.selectedShop}`);
        this.sub$.add(
            this.uploadFileSvc.allFilesLoaded().subscribe(data => {
                if (!data) {
                    return;
                }
                let file = data[0];
                if (!file) {
                    return;
                }
                file = JSON.parse(file.data);
                this.notify.showSuccessMessage('Uploaded successfully');
                this.fileInput.nativeElement.value = '';
                this.uploadFileSvc.filesLoadedObserver.next(null);
                this.dialog.close();
            })
        );
    }

    ngOnDestroy(): void {
        this.sub$.unsubscribe();
    }
}
